import { create } from "../../../common/utils/zustand_state_manager";
import { useComprasServices } from "./use_services";
import { IComprasRepository } from "../../../features/compras/domain/repositories/compras_repositories";
import { ComprasRepository } from "../../../features/compras/data/repositories/compras_repositories";

/**
 * useComprasRepositories
 */

type State = {
  comprasRepository: IComprasRepository,
};

export const useComprasRepositories = create<State>((set, get) => {
  const { comprasService } = useComprasServices.getState();
  return ({
    comprasRepository: new ComprasRepository(comprasService),
  });

});